import React from "react";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";
import WhatsAppIcon from "./WhatsAppIcon"
import ScrollToTopButton from "./ScrollToTopButton"
function Layout() {
  return (
    <>
      <Header />
      <Outlet />
      <ScrollToTop />
      <ScrollToTopButton />
      <WhatsAppIcon /> 
      <Footer />
    </>
  );
}

export default Layout;
